import styled from 'styled-components';

export const KPIContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
  width: 100%;
  padding: 0;
  margin: 20px 0;

  div {
    width: 100%;
  }
`;

export const KPIContainerMobile = styled.div``;
